import { Injectable, signal } from '@angular/core';
import { NetworkService } from './network.service';

@Injectable({
  providedIn: 'root'
})
export class AiAgentService {

  public _aiAgents = signal<any[] | null>(null);
  aiAgents = this._aiAgents.asReadonly();
  isWhiteLabel = signal<boolean>(false);
  whitelabelAgencyId = signal<string | null>(null);

  constructor(
    public networkService: NetworkService,
  ) { }

  get getLanguage() {
    try {
      const storedLang = localStorage.getItem('language');
      const parsedLang = storedLang ? JSON.parse(storedLang) : null;
      return parsedLang?.value || 'en';
    } catch (error) {
      return 'en';
    }
  }
}
